// Stack1.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Stack1({ dialog, stackBookChapter, handleDialogClose }){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const bookList = useSelector((state) => state.home.bookList);
  // const confirmedBookChapterList = useSelector((state) => state.home.confirmedBookChapterList);
  //const tabVerseList = useSelector((state) => state.verse.tabVerseList);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
  // const selectedVerses = useSelector((state) => state.verse.selectedVerses);
  //const hasNoteVerses = useSelector((state) => state.verse.hasNoteVerses);

  const byStack1SetTabVerseListNew = (e, {book, chapter}) => {
    let showLeftArrow;
    let showRightArrow;
    if (book === 1 && chapter === 1) {
      showLeftArrow = false;
      showRightArrow = true;
    } else if (book === 66 && chapter === 22) {
      showLeftArrow = true;
      showRightArrow = false;
    } else {
      showLeftArrow = true;
      showRightArrow = true;
    }
    return tabVerseListNew.map((item, index) => index === e ? { ...item, book: book, chapter: chapter, showLeftArrow: showLeftArrow, showRightArrow: showRightArrow } : item)
    // dispatch(setTabVerseListNew(list));
  }

  const handleOnClick = (tabNumber) => {

    dispatch(setViewArea('Tab'+tabNumber));
    dispatch(setConfirmedTabNumber(tabNumber));
    postHistoryListItem({ book: stackBookChapter.book, chapter: stackBookChapter.chapter}, 'Stack1');
    handleDialogClose();
    if (dialog === 3) dispatch(setSearchTabNumber(tabNumber));

    let list = byStack1SetTabVerseListNew(tabNumber, stackBookChapter);
    // let currentTabVerseListNewItem = list[tabNumber];
    // if (currentTabVerseListNewItem.book !== stackBookChapter.book || currentTabVerseListNewItem.chapter !== stackBookChapter.chapter) {
    //   let newTabVerseListNewItem = { ...list[tabNumber], book: stackBookChapter.book, chapter: stackBookChapter.chapter, verses: [], read: false };
    //   const updatedTabVerseListNew = replaceTabVerseListNewItem(list, tabNumber, newTabVerseListNewItem);
    //   dispatch(setTabVerseListNew(updatedTabVerseListNew));    
    // }
    dispatch(setTabVerseListNew(list));
  };

return (
  <div>

  <Grid container rowSpacing={2}>

    <Grid
      size={12} 
      sx={{ 
        display: 'flex',
        justifyContent: 'center' }}
    >
      那個經文顯示區？
    </Grid>

    <Grid
      size={12} 
      sx={{ 
        display: 'flex',
        justifyContent: 'center' }}
    >
              <ButtonGroup 
                variant="outlined" 
                size='medium'
                sx={{
                  height: 35,
                  border: '1px solid',
                  borderColor: 'primary.main',
                  '& .MuiButtonGroup-grouped': { border: 'none' },
                  '& .MuiButtonGroup-grouped:not(:last-of-type)': {
                    borderRight: '1px solid',
                  },
                }}
              >
        {/* <Stack direction="row" spacing={1}> */}
            <Button sx={{width: '70px', padding: 1}} variant="outlined" onClick={() => handleOnClick(0)}>{getTabLabel(bookList, tabVerseListNew, 0)}</Button>
            <Button sx={{width: '70px', padding: 1}} variant="outlined" onClick={() => handleOnClick(1)}>{getTabLabel(bookList, tabVerseListNew, 1)}</Button>
            <Button sx={{width: '70px', padding: 1}} variant="outlined" onClick={() => handleOnClick(2)}>{getTabLabel(bookList, tabVerseListNew, 2)}</Button>
            <Button sx={{width: '70px', padding: 1}} variant="outlined" onClick={() => handleOnClick(3)}>{getTabLabel(bookList, tabVerseListNew, 3)}</Button>
        </ButtonGroup>
    </Grid>

  </Grid>

  </div>
)
}

// export{
//     Stack1,
// };